/**
 * Calculates the total working time for an examination.
 *
 * @param examination - The examination object containing tasks with working times.
 * @returns The total working time of all tasks in the examination. Returns 0 if the examination is undefined.
 *
 * Usage:
 * const totalWorkingTime = getExaminationWorkingTime(examination);
 */
import { Examination } from "../graphql/types"

export const getExaminationWorkingTime = (
  examination: Examination | undefined
): number => {
  if (!examination || !examination.tasks) {
    return 0
  }
  return examination.tasks.reduce((total, task) => total + task.workingTime, 0)
}
